import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  checklistTemplateEditorMutationKeys,
  checklistTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useCreateChecklistTemplateVersion = (
  options?: UseMutationOptions<
    string,
    RequestErrorType,
    RequestTypes['createChecklistTemplateVersion']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...checklistTemplateEditorMutationKeys.createVersion,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: checklistTemplateKeys._def,
      })
    },
  })
}
